// extracted by mini-css-extract-plugin
export default {"App":"main_App__yGv5p","mask":"main_mask__GLxzh","active":"main_active__2B56v","outer":"main_outer__7qwau","tab":"main_tab__FBrcy"};